import { useEffect } from 'react'

let lockCount = 0
let prevHtmlOverflow = ''
let prevHtmlOverscroll = ''
let prevBodyOverflow = ''

function acquireBodyScrollLock() {
  if (lockCount === 0) {
    const html = document.documentElement
    prevHtmlOverflow = html.style.overflow
    prevHtmlOverscroll = html.style.overscrollBehavior
    prevBodyOverflow = document.body.style.overflow
    html.style.overflow = 'hidden'
    html.style.overscrollBehavior = 'none'
    document.body.style.overflow = 'hidden'
  }
  lockCount += 1
  return () => {
    lockCount = Math.max(0, lockCount - 1)
    if (lockCount === 0) {
      document.documentElement.style.overflow = prevHtmlOverflow
      document.documentElement.style.overscrollBehavior = prevHtmlOverscroll
      document.body.style.overflow = prevBodyOverflow
    }
  }
}

/** Locks document scroll while `locked` is true. Nested callers share one lock. */
export function useBodyScrollLock(locked: boolean) {
  useEffect(() => {
    if (!locked) return
    return acquireBodyScrollLock()
  }, [locked])
}
